
// @ts-check
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageSubTitle from "@/components/Form/PageSubTitle/PageSubTitle";
import { useEffect, useState } from "react";
import Button from "@/components/Form/Button/Button";
import { useTranslation } from "react-i18next";
import { useListAttributesByEntityQuery } from "@/services/customAtrributes/customAttributesReducer";
import { setClaimItemsAttributes } from "./attributeSlice";
import CustomAttribute from "@/components/CustomAttribute/CustomAtrribute";
import { AttributeType } from "@/pages/CaseDetail/Configuration/Attributes/type";
import { MotifErrorMessage, MotifProgressLoader } from "@/libs/@ey-xd/motif-react";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { useCase } from "@/features/case/use-case";
import useResetAllClaimItemsStore from "../useResetAllClaimItemsStore";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { CANCEL_BUTTON_VARIANT, NEXT_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { ActiveTabsOrder } from "@/menuData";
import NotificationGrid from "@/components/Notification/NotificationGrid";

interface DebtorProps {
  goToNextTab: () => void;
}

export default function Attributes({ goToNextTab }: DebtorProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const caseData = useCase();
  const resetAllClaimItemsStore = useResetAllClaimItemsStore();
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [notificationVisible, setNotificationVisible] = useState(false);
  const { data:attributesDataValue, isLoading, error, refetch } = useListAttributesByEntityQuery({
    CaseId: caseData.caseId,
    EntityType: 2,
    IsCreate: true,
  });
  const attributesValue = useSelector(
    (state: any) => state.claimSetupAttributes.attributes
  );
  const hideDocumnetAttribute=()=>{
    let filteredAttributes :any = []
    if (attributesDataValue) {
      filteredAttributes = attributesDataValue?.filter((x: any) => {
        return x.value.attributeType !== AttributeType.Document;
      });
     
    }
  return filteredAttributes
  }
  const [isError, setIsError] = useState(false);
  const [attributesData, setAttributesData] = useState<any>(undefined);
  const [customAttributesValue,setCustomAttributesValues]=useState<any>([])

  useEffect(() => {
    const filteredAttributes = hideDocumnetAttribute();
    setAttributesData(filteredAttributes);
    if (filteredAttributes && attributesValue.length === 0) {
      setCustomAttributesValues([...filteredAttributes]);
    }
    else{
      setCustomAttributesValues([...attributesValue]);
    }
    // eslint-disable-next-line
  }, [attributesDataValue]);
  useEffect(()=>{
    dispatch(setClaimItemsAttributes(customAttributesValue));
  
  },[customAttributesValue,dispatch])
  useEffect(() => {
    dispatch(setDiscardEditMode({ editMode: true }));
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, []);


  const isDisabled = () => {
    var disabled = false;
    let numberNotInRangeLabels:any=[]

    const required = attributesValue.filter((x: any) => {
      if (x.value.attributeType === AttributeType.Number) {
        let metaData=JSON.parse(x.metadataJSON);
        if (!(Number(x.value.numberValue) >=Number(metaData.minimum) &&  Number(x.value.numberValue) <= Number(metaData.maximum)) && x.value.numberValue !== "" && x.value.numberValue !== null) {
          numberNotInRangeLabels.push(x.name);
        }
      }
      return x.isRequired;
    });
    if(numberNotInRangeLabels.length>0){
      setNotificationVisible(true);
      setNotification({
        ...notification,
        ...notification,
        show: true,
        message: t("global.globalNotifications.numberOutOfRange",{attributeName:numberNotInRangeLabels?.join(",")}),
        type: "error",
      });
      return true
    }

    required.find((x: any) => {
      switch (x.value.attributeType) {
        case AttributeType.FreeText:
          disabled = !x.value.textValue;
          break;
        case AttributeType.Number:
          disabled = !x.value.numberValue && x.value.numberValue !== 0;
          break;
        case AttributeType.Boolean:
          disabled = !x.value.booleanValue && x.value.booleanValue !== false;
          break;
        case AttributeType.Date:
          disabled = !x.value.dateValue;
          break;
        case AttributeType.SingleSelect:
          disabled = !x.value.selectedValue;
          break;
        case AttributeType.MutliSelect:
          disabled =
            !x.value.selectedValues || x.value.selectedValues.length === 0;
          break;
        case AttributeType.Currency:
          disabled =x.value.amount===0 || x.value.amount?false:true;
          break;
        // case AttributeType.Document:
        //   disabled = !x.value.displayName;
        //   break;
        default:
          disabled = false;
      }
      return disabled;
    });

    return disabled;
  };

  let missingRequiredFieldsList = useCallback(() => {
      const errorFieldsList: string[] = [];
  
      var isError = false;
      const required = attributesValue?.filter((x: any) => {
        return x.isRequired;
      });
  
      required?.map((x: any) => {
        switch (x.value.attributeType) {
          case AttributeType.FreeText:
            isError = !x.value.textValue;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.Number:
            isError = !x.value.numberValue && x.value.numberValue !== 0;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.Boolean:
            isError = !x.value.booleanValue && x.value.booleanValue !== false;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.Date:
            isError = !x.value.dateValue;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.SingleSelect:
            isError = !x.value.selectedValue;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.MutliSelect:
            isError =
              !x.value.selectedValues || x.value.selectedValues.length === 0;
            return isError && errorFieldsList.push(x.name);
          case AttributeType.Currency:
            isError = x.value.amount === 0 || x.value.amount ? false : true;
            return isError && errorFieldsList.push(x.name);
        }
        return true;
      });
      setErrorFields(errorFieldsList);
      return errorFieldsList;
    }, [attributesValue]);

  const handleNextClick = () => {
    if(missingRequiredFieldsList().length > 0){
      return;
    }
    if (isDisabled()) {
      setIsError(true);
    } else {
      setIsError(false)
      goToNextTab();
    }
  };

  const confirmationModalCancelHandler = () => {
    setIsVisible(false);
    dispatch(setDiscardEditMode({ editMode: true }));

  };

  const confirmationModalDeleteHandler = () => {
    setIsVisible(false);
    resetAllClaimItemsStore();
    navigate(`/case/${caseData.caseId}/?activeTab=${ActiveTabsOrder.CLAIM}`);
  };
  if (isLoading) {
    return <MotifProgressLoader />;
  }
  if (error) {
    return <div>...Error</div>; 
  }
  return (
    <>
     {notificationVisible && (
        <NotificationGrid
          show={notification.show}
          message={notification.message}
          type={notification.type}
          onClose={() =>
            setNotification({
              show: false,
              message: "",
              type: "success",
            })
          }
        />
      )}
      <PageSubTitle
        title={"pages.claims.claimCreate.cliemAttributeTab.title"}
        description={"pages.claims.claimCreate.cliemAttributeTab.description"}
      />

      <div className="pad-v-25 motif-row">
        {attributesData && attributesValue.length === attributesData.length ? (
          attributesData.map((attribute: any, index: number) => {
            return (
              <>
                <CustomAttribute
                  customAttributeDetails={{
                    ...attribute,
                    metadataJSON: JSON.parse(attribute.metadataJSON),
                  }}
                  customAttributeType={attribute.value.attributeType}
                  attributeValue={customAttributesValue}
                  setAttributeValue={setCustomAttributesValues}
                  index={index}
                  key={index}
                  errorFields={errorFields}
                  setErrorFields={setErrorFields}
                />
                </>
            );
          })
        ) : (
          <></>
        )}
      </div>

      <div>
        {isError ? (
          <MotifErrorMessage>
            {t("pages.configuration.attributes.requiredFields")}
          </MotifErrorMessage>
        ) : (
          <></>
        )}
      </div>

      <div className="motif-row justify-content-end mar-t-70 button-container sticky-footer">
        <div className="display-flex">
            <Button
              type="button"
              label={t("global.globalActions.cancel")}
              variant={CANCEL_BUTTON_VARIANT}
              className="cancelBtn"
              onClickHandler={() =>{setIsVisible(true);      dispatch(setDiscardEditMode({ editMode: false }));
            }}
            />
            <Button
              label={t("global.globalActions.next")}
              variant={NEXT_BUTTON_VARIANT}
              onClickHandler={handleNextClick}
            />
        </div>
        <ConfirmationModal
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          cancelBtnApproveHandler={confirmationModalDeleteHandler}
          cancelBtnRejectHandler={confirmationModalCancelHandler}
        />
      </div>
    </>
  );
}
